<template>
    <b-container class="region-logo-image-wrap" v-if="allItems.length">
        <b-row>
            <b-col md="6">
                <h1>Unsere Partnerübersicht für Deine Stadt und Umgebung</h1>
                <h5 class="mb-4">Geschenkkarte bei einem oder mehreren Partnern einlösbar</h5>
                <div class="region-logo-image">
                    <b-button v-for="item in allItems" :key="item.id" :variant="item.id === selectedItem.id ? 'primary' : 'outline-secondary'" @click="switchRegionLogoImage(item)">{{item.name}}</b-button>
                </div>
                <p>Und bald auch in Deiner Stadt…</p>
            </b-col>
            <b-col md="6">
                <a :href="selectedItem.vouchers_url" :style="'display:block;background-image: url('+selectedItem.url+');background-position: center;background-size: contain;background-repeat: no-repeat;min-height: 500px;'"></a>
            </b-col>


        </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'RegionLogoImage',
    props: {
        items: {
            type: Array,
            default: [],
        },
    },
    data () {
        return {
            allItems: this.items,
            selectedItem: this.items.length ? this.items[0] : null,
        };
    },
    methods: {
        switchRegionLogoImage(item) {
            this.selectedItem = item;
        },
    },
}
</script>
